import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PortalContextProvider } from '@core';
import { PortalType } from '@shared';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { GetStatusesWithPagingQuery } from './get-statuses-with-paging.query';
import { GetStatusesWithPagingResult } from './get-statuses-with-paging.result';
import { StatusState } from '../../states/status.state';

@Injectable({ providedIn: 'root' })
export class GetStatusesWithPagingUseCase {
  private readonly _repository = inject(StatusRepository);
  private readonly _state = inject(StatusState);
  private readonly _portalContext = inject(PortalContextProvider);

  public execute(query: GetStatusesWithPagingQuery): Observable<GetStatusesWithPagingResult> {
    const isCases = this._portalContext.currentPortalType() === PortalType.Cases;

    return this._repository.getStatusesWithPaging(query).pipe(
      map((result) => {
        if (isCases) {
          this._state.setCasesStatuses(result.data);
          this._state.setCasesStatusesCount(result.totalElements);
        } else {
          this._state.setInvestigationsStatuses(result.data);
          this._state.setInvestigationsStatusesCount(result.totalElements);
        }
        return {
          data: result.data,
          totalElements: result.totalElements,
        };
      }),
    );
  }
}
